module.exports = __webpack_public_path__ + "resources/icon-like.a4525f7125d4ef1a.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-footer/img/icon-like.png
// module id = 845
// module chunks = 0 1